import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import * as fromApp from "../../store/app.reducer";
import * as selectors from "../../store/app.selectors";
import * as AuthActions from "../../auth/store/auth.actions";
import { playClaimAnimation } from "../../discount-coupons/coupon-claim-animation";
import { couponIssuanceMessage } from "../../discount-coupons/coupon-issuance-message";
import { FullscreenImagePopupComponent } from "../../popups/fullscreen-image-popup/fullscreen-image-popup.component";
import * as _ from "lodash";
import { catchError, first, map, retry, tap, timeout, switchMap } from "rxjs/operators";
import * as CatalogActions from "../../catalog/store/catalog.actions";

import { of, Observable, Subject, combineLatest, defer } from "rxjs";
import * as CouponsActions from "../../discount-coupons/store/coupons.actions";
import * as DisableFinalPriceActions from "../../store/disable-final-price/disable-final-price.actions";
import { AlertController, ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class DataStorageService {
  private couponStateWatching = false;
  private couponCollection: any;
  private couponCollectionRevision = 0;
  private couponSessionRevision = 0;
  private couponFeedbackSessionChanged: Subject<"session" | "credential">;
  private couponSubmissionRevision = 0;
  private couponLoginPending = false;
  private couponSharedAccount = false;
  private couponSessionIdentity: any[];
  private couponReadbackSequence = 0;
  private appliedCouponReadbackSequence = 0;
  private developerMode: boolean;
  private stagePath: string;
  constructor(
    private http: HttpClient,
    private store: Store<fromApp.AppState>,
    private alertController: AlertController,
    private translateService: TranslateService,
    private modalController: ModalController
  ) {
    this.store.select("developerMode").subscribe((state) => {
      if (state && !_.isEqual(this.developerMode, state.developerMode)) {
        this.developerMode = _.cloneDeep(state.developerMode);
        if (this.developerMode) {
          this.stagePath = "mov5dev";
        } else {
          this.stagePath = "mov5";
        }
      }
    });
  }

  fetchGroupApp(group) {
    console.log("group from fetch", group);
    return this.http
      .get("https://data.deliverymanager.gr/" + group + "/groupapp.json")
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchTheme(group) {
    return this.http
      .get(
        "https://data.deliverymanager.gr/mobileorderthemes/" + group + ".json"
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchAllStores(group) {
    return this.http
      .get("https://data.deliverymanager.gr/" + group + "/stores.json")
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  checkStoreOnline(data) {
    return this.http
      .post(
        "https://n3jchx7l3wz62ay73snrjuoone0zqwsy.lambda-url.eu-west-1.on.aws",
        JSON.stringify(data)
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  //Static Pages

  fetchStaticPages(store_id, group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-get-static-pages",
        { store_id: store_id, group: group },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  //Address APIS

  fetchFixedAddressData(fixed_address_id, group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-get-fixed-address-data",
        { fixed_address_id: fixed_address_id, group: group },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchFixedPointsAddresses(group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-fixed-addresses",
        { group: group },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  // loyalty system
  fetchUserLoyaltyProducts(mo_token, data) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-loyaltyapp-fetch-customer-products",
        data,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchHallOfFame(mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-loyaltyapp-ranking",
        {},
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  createLoyaltyCoupon(loyalty_product_rule_id, use_type, mo_token, store_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-loyaltyapp-create-coupon",
        {
          loyalty_product_rule_id,
          use_type,
          store_id,
        },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchGroupContests(group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-contests",
        { group },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchCustomerDraws(mo_token, contest_id, winners_fileName, status) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-customer-draws",
        { contest_id, winners_fileName, status },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  handleImageUpload(fileName, directory) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-customer-upload-profile-image",
        {
          fileName: fileName,
          directory: directory,
        }
      )
      .pipe(retry(1));
  }

  createOrder(params, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" + this.stagePath + "/createorder",
        JSON.stringify(params),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000));
  }

  createRevolutPayment(storeId: string, orderId: string, moToken: string) {
    // Revolut checkout uses the production API in both app modes.
    return this.http.post<{ success: boolean; checkout_url?: string; paid?: boolean }>(
      "https://api.deliverymanager.gr/mov5/dm-revolut-payments",
      { store_id: storeId, order_id: orderId },
      { headers: new HttpHeaders({ "Content-Type": "application/json", Authorization: moToken }) }
    ).pipe(timeout(20000));
  }

  changeOrderPaymentMethod(data, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/changeOrderPaymentMethod",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  checkAutoCompleteAddres(
    street,
    street_number,
    postal_code,
    userLat,
    userLng,
    googleLat,
    googleLng,
    languageCode,
    googleMapsCountryCode,
    group
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-check-autocomplete-address",
        JSON.stringify({
          street,
          street_number,
          postal_code,
          userLat,
          userLng,
          googleLat,
          googleLng,
          languageCode,
          googleMapsCountryCode,
          group,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  getAddressFromCoordinates(
    gpsLat,
    gpsLng,
    languageCode,
    googleMapsCountryCode,
    group,
    postCodeForCheck
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-get-address-from-coordinates",
        JSON.stringify({
          gpsLat,
          gpsLng,
          languageCode,
          googleMapsCountryCode,
          group,
          postCodeForCheck,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  checkMarker(data) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-check-marker",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  fetchCustomerFavoriteProducts(store_id, mo_token, migration_customer_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-customer-favorite-products",
        JSON.stringify({
          store_id,
          migration_customer_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  fetchCustomerPreviousOrders(
    store_id,
    selectedLanguage,
    groupAppLanguages,
    mo_token,
    pickup,
    dinein,
    preorderData,
    dinein_table_id,
    vatBasedCustomerProductsActive,
    migration_customer_id
  ) {
    let baseLanguage: string = "";
    const langs = _.cloneDeep(groupAppLanguages);
    const moBaseLanguage = _.find(langs, { mo_base: true });
    if (moBaseLanguage && moBaseLanguage.code) {
      baseLanguage = moBaseLanguage.code;
    }
    let preorder = null;
    let preorder_day = null;
    let preorder_time = null;
    if (
      preorderData &&
      preorderData.preorder &&
      preorderData.preorder_day &&
      preorderData.preorder_time
    ) {
      preorder = true;
      preorder_day = preorderData.preorder_day;
      preorder_time = preorderData.preorder_time;
    }

    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-previous-orders-products",
        JSON.stringify({
          store_id,
          selectedLanguage,
          baseLanguage,
          pickup,
          dinein,
          preorder,
          preorder_day,
          preorder_time,
          dinein_table_id,
          vatBasedCustomerProductsActive,
          migration_customer_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  handleFavoriteProduct(
    store_id,
    product_id,
    type,
    mo_token,
    migration_customer_id
  ) {
    console.log("params", store_id, product_id, mo_token, type);
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-handle-favorite-product",
        JSON.stringify({
          store_id,
          product_id,
          type,
          mo_token,
          migration_customer_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(retry(1));
  }

  checkFormattedAddress(
    group,
    userLat,
    userLng,
    languageCode,
    customer_id,
    address_id
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-check-formatted-address",
        JSON.stringify({
          group,
          userLat,
          userLng,
          languageCode,
          customer_id,
          address_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  moCheckCouponRuleId(obj) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mo_check_coupon_rule_id",

        JSON.stringify(obj),

        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  moCheckAffiliateCouponCode(obj) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mo-check-affiliate-coupon-code",

        JSON.stringify(obj),

        {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  private watchCouponState(): void {
    if (this.couponStateWatching) return;
    this.couponStateWatching = true;
    this.couponFeedbackSessionChanged = new Subject<"session" | "credential">();
    this.store.select("customerCoupons").subscribe((state) => {
      if (state.allCoupons !== this.couponCollection) {
        this.couponCollection = state.allCoupons;
        this.couponCollectionRevision++;
      }
    });
    let previousToken: string;
    this.store.select("auth").subscribe((state) => {
      const loginPending = state.loginState === "login_loading";
      this.couponSharedAccount = [state.user?.only_dinein, state.user?.system_visitor_slot, state.user?.only_visitor_slot]
        .some(flag => flag === true || flag === "true");
      const identity = [state.user?.group, state.user?.customer_id, state.user?.mobile,
        state.user?.only_visitor === true || state.user?.only_visitor === "true",
        !!state.mo_token && state.mo_token !== "null", state.logoutFlagTimestamp, loginPending, this.couponSharedAccount];
      const sessionChanged = !_.isEqual(identity, this.couponSessionIdentity);
      // A login can replace the credential before the profile arrives. A pending
      // submission must stop on either change, even if the old token is restored.
      if (sessionChanged || state.mo_token !== previousToken) {
        this.couponSubmissionRevision++;
        this.couponFeedbackSessionChanged.next(sessionChanged ? "session" : "credential");
      }
      previousToken = state.mo_token;
      this.couponLoginPending = loginPending;
      if (sessionChanged) {
        this.couponSessionIdentity = identity;
        this.couponSessionRevision++;
      }
    });
  }

  async presentCouponReceipt(result: any): Promise<void> {
    let message = couponIssuanceMessage(result);
    if (result.issued === true && result.replayed === false && !result.account_changed && result.claim_lottie &&
        typeof window !== "undefined" && typeof AbortController !== "undefined" && typeof window.matchMedia === "function" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.watchCouponState();
      const controller = new AbortController();
      let changed = false, navigated = false;
      const subscription = this.couponFeedbackSessionChanged.subscribe(reason => { changed = changed || reason === "session"; controller.abort(); });
      const leave = () => { navigated = true; controller.abort(); };
      const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
      const reduce = () => { if (motion.matches) controller.abort(); };
      window.addEventListener("pagehide", leave);
      window.addEventListener("popstate", leave);
      document.addEventListener("ionViewWillLeave", leave, true);
      motion.addEventListener?.("change", reduce);
      try {
        if (await playClaimAnimation(result.claim_lottie, controller, async (canvas, close) => {
          const modal = await this.modalController.create({
            component: FullscreenImagePopupComponent,
            componentProps: {
              claimAnimationHost: canvas,
              claimMessage: this.translateService.instant(message),
              claimCouponName: result.coupon_description,
              claimCloseLabel: this.translateService.instant("coupon_animation_close"),
              claimCloseAction: close,
            },
            cssClass: "fullscreen-image-popup-lottie coupon-claim-popup",
            backdropDismiss: false,
          });
          modal.setAttribute("aria-label", this.translateService.instant(message));
          return modal;
        })) return;
      } catch { /* Issuance is confirmed; show its normal text if the player fails. */ }
      finally {
        subscription.unsubscribe();
        window.removeEventListener("pagehide", leave);
        window.removeEventListener("popstate", leave);
        document.removeEventListener("ionViewWillLeave", leave, true);
        motion.removeEventListener?.("change", reduce);
      }
      if (navigated) return;
      if (changed) message = "one_time_code_previous_account";
    }
    const alert = await this.alertController.create({
      header: this.translateService.instant("information"),
      message: this.translateService.instant(message),
      buttons: ["OK"],
    });
    await alert.present();
  }

  private getClaimCoupons(moToken: string): Observable<any> {
    return combineLatest([
      this.store.select("groupApp"),
      this.store.select(selectors.getStoreInfo),
    ]).pipe(first(), switchMap(([groupState, storeInfo]) => {
      const kioskFetch = !!(storeInfo?.dm_kiosk_app_active &&
        !groupState?.groupApp?.design_settings?.dm_kiosk_app_disable_mobileorder);
      return this.requestCustomerCoupons(moToken, kioskFetch, kioskFetch);
    }));
  }

  moCheckCouponCode(obj) {
    const code = obj?.coupon_code;
    if (typeof code === "string" && code.replace(/[\s-]/g, "").startsWith("~")) return this.claimPrintedCoupon(obj);
    if (typeof code === "string" && code.length === 9 && /^[0-9]{9}$/.test(code) && !obj.coupon_rule_id && !obj.affiliate_coupon_code) {
      this.watchCouponState();
      const revision = this.couponSubmissionRevision;
      return this.checkNumericLegacyCode({ ...obj, numeric_claim_capable: true }, revision).pipe(switchMap((result: any) =>
        result?.check_authenticated_numeric === true ? this.claimPrintedCoupon(obj, revision) : of(result)
      ));
    }
    return this.checkLegacyCouponCode(obj);
  }

  private checkNumericLegacyCode(obj, revision: number): Observable<any> {
    const changed = { success: false, comment_id: "errorMessages.classic_error" };
    if (this.couponSharedAccount) return of({ success: false, comment_id: "one_time_code_login_required" });
    if (this.couponLoginPending || revision !== this.couponSubmissionRevision) return of(changed);
    return this.checkLegacyCouponCode(obj).pipe(map(result =>
      revision === this.couponSubmissionRevision ? result : changed
    ));
  }

  private claimPrintedCoupon(obj, numericRevision?: number): Observable<any> {
    this.watchCouponState();
    return this.store.select("auth").pipe(first(), switchMap((state) => {
      const numeric = numericRevision !== undefined;
      if (this.couponSharedAccount) return of({ success: false, comment_id: "one_time_code_login_required" });
      if (state.loginState === "login_loading" || (numeric && numericRevision !== this.couponSubmissionRevision)) {
        return of({ success: false, comment_id: "errorMessages.classic_error" });
      }
      const session = { ...state, user: state.user && { ...state.user }, revision: this.couponSessionRevision };
      const feedbackRevision = this.couponSubmissionRevision;
      if (!state.mo_token || state.mo_token === "null" || !state.user?.group || !state.user?.customer_id || !state.user?.mobile ||
          state.user.only_visitor === true || state.user.only_visitor === "true") {
        if (!numeric) return of({ success: false, comment_id: "one_time_code_login_required" });
        return this.checkNumericLegacyCode(obj, numericRevision).pipe(switchMap((legacy: any) =>
          of(legacy?.comment_id === "coupon_does_not_exist" ? { ...legacy, comment_id: "one_time_code_login_required" } : legacy)
        ));
      }
      if (numeric && (obj.group !== state.user.group || (obj.mobile && obj.mobile !== state.user.mobile))) {
        return of({ success: false, comment_id: "errorMessages.unauthorized" });
      }
      return this.useCouponRule({ redemption_mode: "one_time_v1", coupon_code: obj.coupon_code, store_id: obj.store_id }, session.mo_token).pipe(
        switchMap((result: any) => {
          if (numeric && result?.numeric_unregistered === true && result.success === false) {
            return this.checkNumericLegacyCode(obj, numericRevision);
          }
          if (!result?.issued) return of(result && ["unauthorized", "classic_error"].includes(result.comment_id) ? { ...result, comment_id: "errorMessages." + result.comment_id } : result);
          const readbackSequence = ++this.couponReadbackSequence;
          let readbackRevision: number;
          return defer(() => {
            readbackRevision = this.couponCollectionRevision;
            return this.getClaimCoupons(session.mo_token);
          }).pipe(
            tap((coupons: any) => {
              // A socket/page refresh may have published a newer collection
              // while this read was pending. Retry this read, never replace it.
              if (readbackRevision !== this.couponCollectionRevision || !coupons?.success || !coupons.coupons?.some((coupon) => coupon.label === result.coupon_label)) throw new Error("coupon_readback_pending");
            }),
            retry({ count: 2, delay: 300 }),
            timeout(3000),
            catchError(() => of(null)),
            switchMap((coupons: any) => this.store.select("auth").pipe(first(), switchMap((currentSession) => {
              if (session.revision !== this.couponSessionRevision || !currentSession.mo_token || !_.isEqual(
                [session.user?.group, session.user?.customer_id, session.user?.mobile],
                [currentSession.user?.group, currentSession.user?.customer_id, currentSession.user?.mobile])) return of({ ...result, coupons_refreshed: false, account_changed: true });
              // Inputs can overlap across navigation. An older response must
              // never replace a collection already read by a newer request.
              if (readbackSequence < this.appliedCouponReadbackSequence || readbackRevision !== this.couponCollectionRevision) return of({ ...result, coupons_refreshed: false });
              if (coupons?.success) {
                this.appliedCouponReadbackSequence = readbackSequence;
                this.store.dispatch(new CouponsActions.SetAllCoupons(coupons.coupons));
                this.store.dispatch(new DisableFinalPriceActions.SetTriggerFinalPriceTimestamp(new Date().getTime()));
              }
              const receivedCoupon = coupons?.success ? coupons.coupons.find(coupon => coupon.label === result.coupon_label) : null;
              const description = receivedCoupon?.description_langs?.[this.translateService.currentLang] || receivedCoupon?.description;
              return of({ ...result, coupons_refreshed: coupons?.success === true,
                ...(typeof description === "string" ? { coupon_description: description } : {}) });
            })))
          );
        }),
        map((feedback: any) => {
          if (!feedback?.claim_lottie || feedbackRevision === this.couponSubmissionRevision) return feedback;
          const { claim_lottie, ...withoutAnimation } = feedback;
          return withoutAnimation;
        })
      );
    }));
  }

  private checkLegacyCouponCode(obj): Observable<any> {
    if (obj.coupon_rule_id) {
      return this.moCheckCouponRuleId(obj);
    } else if (obj.affiliate_coupon_code) {
      return this.moCheckAffiliateCouponCode(obj);
    } else {
      return this.http
        .post(
          "https://api.deliverymanager.gr/" +
            this.stagePath +
            "/mo-check-coupon-code",

          JSON.stringify(obj),

          {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
            }),
          }
        )
        .pipe(timeout(10000));
    }
  }

  sendAffiliateEmail(email_to, store_id, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-affiliate-email-sharing",
        { email_to, store_id },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe();
  }

  //get the whole catalog (retries 3 times if failed)
  getCatalog(store_id, languagePath) {
    console.log(
      "https://cdn.deliverymanager.gr/" +
        store_id +
        "/" +
        languagePath +
        "/catalog.json"
    );
    return this.http
      .get(
        "https://cdn.deliverymanager.gr/" +
          store_id +
          "/" +
          languagePath +
          "/catalog.json"
      )

      .pipe(timeout(20000))
      .pipe(retry(2));
  }

  searchCatalog(selectedLanguage, store_id, search_term, search_categories) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-search-items",
        {
          selectedLanguage: selectedLanguage,
          store_id: store_id,
          search_term: search_term,
          search_categories: search_categories,
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getProductDetails(store_id, product_id, languagePath) {
    return this.http
      .get(
        " https://cdn.deliverymanager.gr/" +
          store_id +
          "/" +
          languagePath +
          "/" +
          product_id +
          ".json"
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchProductDetailsUpdatedData(
    store_id,
    group,
    product_id,
    language_code,
    orderPickup,
    dinein,
    preorderData
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-product-updated-data",
        JSON.stringify({
          store_id,
          group,
          product_id,
          language_code,
          orderPickup,
          dinein,
          preorderData,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(20000))
      .pipe(retry(2));
  }

  getAllProductDetails(
    store_id,
    group,
    bundle_option_id,
    language_code,
    orderPickup,
    dineIn,
    root_product_id,
    enable_customer_pricelists,
    enable_customer_pricelists_mobileorder,
    customerPricelist,
    dinein_table_id,
    preorderData,
    parent_bundle_choice_of_root_product,
    selectedAddress
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-option-bundle-choice-products",
        JSON.stringify({
          store_id,
          bundle_option_id,
          language_code,
          orderPickup,
          dineIn,
          root_product_id,
          enable_customer_pricelists,
          enable_customer_pricelists_mobileorder,
          customerPricelist,
          group,
          dinein_table_id,
          preorderData,
          parent_bundle_choice_of_root_product,
          selectedAddress,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(20000))
      .pipe(retry(2));
  }

  updateCustomerData(obj, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/updateCustomerData",
        JSON.stringify(obj),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000))
      .pipe(retry(2));
  }

  get_user_data(
    mo_token,
    active_loyalty_app,
    customerDraws,
    migrating_points_from_group
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/get-customer-data",
        { active_loyalty_app, customerDraws, migrating_points_from_group },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000))
      .pipe(retry(2));
  }

  getUserPricelist(mo_token, store_id, migration_customer_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-customer-prices",
        { store_id, migration_customer_id },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getUserOrders(mo_token, vatBasedCustomerProductsActive, device_id?) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" + this.stagePath + "/getUserOrders",
        JSON.stringify({
          vatBasedCustomerProductsActive: vatBasedCustomerProductsActive,
          device_id: device_id ? device_id : undefined,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchPreviousOrderProducts(
    store_id,
    order_id,
    selectedLanguage,
    groupAppLanguages,
    mo_token,
    pickup,
    dinein,
    preorderData,
    dinein_table_id,
    vatBasedCustomerProductsActive,
    migration_customer_id
  ) {
    let baseLanguage: string = "";
    const langs = _.cloneDeep(groupAppLanguages);
    const moBaseLanguage = _.find(langs, { mo_base: true });
    if (moBaseLanguage && moBaseLanguage.code) {
      baseLanguage = moBaseLanguage.code;
    }
    let preorder;
    let preorder_day;
    let preorder_time;
    if (
      preorderData &&
      preorderData.preorder &&
      preorderData.preorder_day &&
      preorderData.preorder_time
    ) {
      preorder = true;
      preorder_day = preorderData.preorder_day;
      preorder_time = preorderData.preorder_time;
    }
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-previous-order-products",
        JSON.stringify({
          store_id,
          order_id,
          selectedLanguage,
          baseLanguage,
          pickup,
          dinein,
          preorder,
          preorder_day,
          preorder_time,
          dinein_table_id,
          vatBasedCustomerProductsActive,
          migration_customer_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(1));
  }

  getUserOrderDetails(mo_token, order_id, store_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/getUserOrderDetails",
        JSON.stringify({ order_id: order_id, store_id: store_id }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getDineInTables(group, store_id, device_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-dinein-tables",
        { group, store_id, device_id },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getOnlyDineInUserAuth(store_id, group, mobile, table_id, auth_key) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-dinein-table-data",
        { store_id, group, mobile, table_id, auth_key },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  createVisitorSession(
    store_id,
    group,
    device_id,
    mode = "takeaway",
    table_id = null
  ) {
    const body: any = { store_id, group, device_id, mode };
    if (table_id != null) {
      body.table_id = table_id;
    }

    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/createvisitorsession",
        body,
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  releaseVisitorSession(group, visitor_session_id, visitor_slot_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/releasevisitorsession",
        {
          group,
          visitor_session_id,
          visitor_slot_id,
          release_reason: "real_login_upgrade",
        },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  getPreorderDays(store_id, group, language_code) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-get-preorder-days",
        { store_id, group, language_code },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchCustomerPoint(mo_token, loyaltyCardLevelsActive) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/fetchcustomerpoints",
        JSON.stringify({ loyaltyCardLevelsActive: loyaltyCardLevelsActive }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2))
      .pipe(
        tap((resData: any) => {
          if (
            loyaltyCardLevelsActive &&
            resData &&
            resData.data &&
            resData.data.updatedCustomer &&
            !_.isEmpty(resData.data.updatedCustomer)
          ) {
            this.store.dispatch(
              new AuthActions.SetUser(_.cloneDeep(resData.data.updatedCustomer))
            );
          }
        })
      );
  }

  useCouponRule(obj, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-use-coupon-rule",
        JSON.stringify(obj),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  usePoints(obj, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" + this.stagePath + "/usepoints",
        JSON.stringify(obj),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  getCustomerCoupons(
    mo_token,
    generate_kiosk_passwords,
    fetchAlsoKioskCoupons
  ) {
    return this.requestCustomerCoupons(mo_token, generate_kiosk_passwords, fetchAlsoKioskCoupons)
      .pipe(timeout(10000), retry(2));
  }

  private requestCustomerCoupons(
    mo_token,
    generate_kiosk_passwords,
    fetchAlsoKioskCoupons
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/get_customer_coupons",
        JSON.stringify({
          generate_kiosk_passwords: generate_kiosk_passwords,
          fetchAlsoKioskCoupons: fetchAlsoKioskCoupons,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      );
  }

  getCustomerKioskCoupons(mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/get_customer_coupons",
        JSON.stringify({
          kioskCoupons: true,
          generate_kiosk_passwords: true,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getNoUserKioskCouponRulesRewards(store_id, group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-coupon-rules",
        JSON.stringify({
          store_id: store_id,
          group: group,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getCustomerKioskCouponRulesRewards(mo_token, store_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-customer-coupon-rules",
        JSON.stringify({
          store_id: store_id,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getLoyaltyAppCustomerCouponRules(mo_token, store_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-customer-coupon-rules",
        JSON.stringify({
          store_id: store_id,
          loyalty_app: true,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getNoUserLoyaltyAppCouponRules(store_id, group) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-coupon-rules",
        JSON.stringify({
          store_id: store_id,
          group: group,
          loyalty_app: true,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  getReviews(mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" + this.stagePath + "/getReviews",
        JSON.stringify({}),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  sendReview(mo_token, order_id, store_id, platform, questions) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" + this.stagePath + "/sendReview",
        JSON.stringify({
          order_id,
          store_id,
          platform,
          questions,
        }),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  createCardRecurringTransaction(data, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/createCardRecurringTransaction",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000));
  }

  getPiraeusHtml3ds(data, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-get-piraeus-html-3ds",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(3000));
  }

  piraeusCheckoutRecurring3ds(data, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/piraeus-checkout-recurring-3ds",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000));
  }

  verifyBillingInfo(data, mo_token) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/verify-bank-format-billing-address",
        JSON.stringify(data),
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(20000));
  }

  // Without instantDeletion this is the SMS-link request, body {} as before.
  triggerDeleteAccount(
    mo_token,
    instantDeletion?: { instant_delete: true; language_code: string }
  ) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-trigger-delete-customer",
        instantDeletion ? instantDeletion : {},
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(instantDeletion ? 20000 : 10000));
  }

  triggerRestoreAccount(group, mobile, language_code) {
    let url =
      "https://api.deliverymanager.gr/" +
      this.stagePath +
      "/mobileorder-trigger-restore-customer";
    return this.http
      .post(url, { group, mobile, language_code })
      .pipe(timeout(10000));
  }

  loginUposCustomer(group, mobile, password) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-upos-login",
        {
          group,
          mobile,
          password,
          action: "login",
        },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000));
  }

  checkStoreSchedule(store_id, group, languageCode) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-loyaltyapp-check-store-schedule",
        { store_id, group, languageCode },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
          }),
        }
      )
      .pipe(timeout(10000))
      .pipe(retry(2));
  }

  fetchReceiversCoupons(mo_token, affiliate_coupon_code) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-affiliate-fetch-receivers-coupons",
        { affiliate_coupon_code },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  createSendersCoupon(mo_token, coupon, store_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-affiliate-sender-create-coupon",
        { coupon, store_id },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  migrateCustomerPoints(mo_token, memberNumberPhone) {
    return this.http.post(
      "https://api.deliverymanager.gr/" +
        this.stagePath +
        "/mobileorder-manually-migrate-points",
      { memberNumberPhone },
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json; charset=utf-8",
          Authorization: mo_token,
        }),
      }
    );
  }

  fetchReservationTables(group, store_id, lang) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-reservation-tables",
        { group, store_id, language_code: lang },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            // Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchReservations(mo_token, store_id, active_reservation_app, exclusiveStartKey, fetch_type) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-reservations",
        { store_id, active_reservation_app, exclusiveStartKey, fetch_type },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  createReservation(mo_token, reservation) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-handle-reservation",
        { reservation },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  handleReservation(mo_token, reservation: any, type) {
    const res_id = reservation.res_id;
    const store_id = reservation.store_id;
    const customer_notes = reservation.customer_notes || "";
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-handle-reservation",
        { res_id, store_id, type, customer_notes },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  fetchArtistTables(group, store_id, product_id) {
    return this.http
      .post(
        "https://api.deliverymanager.gr/" +
          this.stagePath +
          "/mobileorder-fetch-reservation-tables",
        { group, product_id, store_id },
        {
          headers: new HttpHeaders({
            "Content-Type": "application/json; charset=utf-8",
            // Authorization: mo_token,
          }),
        }
      )
      .pipe(timeout(10000));
  }

  triggerReconnectSocket() {
    this.store.dispatch(
      new AuthActions.SetReconnectSocketTimestamp(Date.now().toString())
    );
  }
  changeBitlyToRealUrlForRedirect(bitlyUrl) {
    return this.http.post(
      "https://api.deliverymanager.gr/" +
        this.stagePath +
        "/mobileorder-check-short-url",
      { bitlyUrl },
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json; charset=utf-8",
        }),
      }
    );
  }
}
